import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { AnalyticsQueryParams } from '@candu-ai/analytics/types';

import { resetSearchState, useAnalyticsQueryParams } from './state';

const urlParamsToSync = [
  AnalyticsQueryParams.UpperTimestamp,
  AnalyticsQueryParams.Timestamp,
  AnalyticsQueryParams.TimeInterval,
  AnalyticsQueryParams.Filters,
];

export const useSyncStateAndUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = useAnalyticsQueryParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetSearchState());
  }, []);

  useEffect(() => {
    let shouldRefreshParams = false;
    Object.entries(query).forEach(([key, value]) => {
      if (searchParams.get(key) !== value) {
        shouldRefreshParams = true;
        searchParams.set(key, value);
      }
    });
    const paramsToDelete = urlParamsToSync.filter((key) => !query[key] && searchParams.has(key));
    paramsToDelete.forEach((param) => {
      searchParams.delete(param);
    });

    if (!shouldRefreshParams && paramsToDelete.length < 1) {
      return;
    }

    setSearchParams(searchParams, { replace: true });
  }, [query]);

  return null;
};
